import { FC } from 'react';
import { BankAccount } from '@mews-commander/data-access';
import { Body, Position } from '@optimus-web/core';
import { TooltippedSpan } from '../tooltip';
import { SpacedComma } from '../typography';
import { bankNameMaxLengthExceeded, getTruncatedBankName } from './utils';

export interface BankAccountNameProps {
    bankAccount: BankAccount;
}

export const BankAccountName: FC<BankAccountNameProps> = ({ bankAccount }) => {
    const { bankName, lastFourDigits } = bankAccount;

    const isMaxLengthExceeded = bankNameMaxLengthExceeded(bankName);
    const newBankName = isMaxLengthExceeded ? getTruncatedBankName(bankName) : bankName;
    const newLastDigits = lastFourDigits ? lastFourDigits.padStart(8, '*') : null;

    const TooltipContent = isMaxLengthExceeded ? (
        <Body size="small" wordBreak="break-all" variant="inverse" align="left">
            {bankName}
        </Body>
    ) : null;

    return (
        <TooltippedSpan tooltip={TooltipContent} tooltipPosition={Position.Bottom}>
            {`${newBankName}${SpacedComma}${newLastDigits}`}
        </TooltippedSpan>
    );
};
